/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Hidden_ToastInputs */



/**
* | output |
* | --- |
* | "Hidden. You can show it again under Settings → Preferences." |
*
* @param {Spaces_Gallery_Hidden_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_hidden_toast = /** @type {((inputs?: Spaces_Gallery_Hidden_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Hidden_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgeblendet. Sie können es unter Einstellungen → Präferenzen wieder einblenden.")
	return /** @type {LocalizedString} */ ("Hidden. You can show it again under Settings → Preferences.")
});